// import React, { createContext, useState, useEffect, useContext } from "react";

// // Create CartContext
// const CartContext = createContext();

// // Custom hook to use CartContext
// export const useCart = () => useContext(CartContext);

// // CartContext Provider
// export const CartProvider = ({ children }) => {
//     const [cartItems, setCartItems] = useState([]);

//     useEffect(() => {
//         const storedCartItems = JSON.parse(localStorage.getItem("cartItems") || "[]");
//         setCartItems(storedCartItems);
//     }, []);

//     const addToCart = (item) => {
//         setCartItems((prevItems) => {
//             const updatedCart = [...prevItems, item];
//             localStorage.setItem("cartItems", JSON.stringify(updatedCart));
//             return updatedCart;
//         });
//     };

//     const removeFromCart = (indexToRemove) => {
//         setCartItems((prevItems) => {
//             const updatedCart = prevItems.filter((_, index) => index !== indexToRemove);
//             localStorage.setItem("cartItems", JSON.stringify(updatedCart));
//             return updatedCart;
//         });
//     };

//     const clearCart = () => {
//         setCartItems([]);
//         localStorage.removeItem("cartItems");
//     };

//     return (
//         <CartContext.Provider value={{ cartItems, addToCart, removeFromCart, clearCart }}>
//             {children}
//         </CartContext.Provider>
//     );
// };

import React, { createContext, useState, useEffect, useContext } from "react";

// Create CartContext
const CartContext = createContext();

// Custom hook to use CartContext
export const useCart = () => useContext(CartContext);

// CartContext Provider
export const CartProvider = ({ children }) => {
    const [cartItems, setCartItems] = useState([]);

    useEffect(() => {
        const storedCartItems = JSON.parse(localStorage.getItem("cartItems") || "[]");
        setCartItems(storedCartItems);
        console.log("Cart items loaded from localStorage:", storedCartItems);
    }, []);

    const addToCart = (item) => {
        setCartItems((prevItems) => {
            const updatedCart = [...prevItems, item];
            localStorage.setItem("cartItems", JSON.stringify(updatedCart));
            console.log("Item added to cart:", item);
            console.log("Updated cart:", updatedCart);
            return updatedCart;
        });
    };

    const removeFromCart = (indexToRemove) => {
        setCartItems((prevItems) => {
            const updatedCart = prevItems.filter((_, index) => index !== indexToRemove);
            localStorage.setItem("cartItems", JSON.stringify(updatedCart));
            console.log(`Item removed at index ${indexToRemove}`);
            console.log("Updated cart after removal:", updatedCart);
            return updatedCart;
        });
    };

    const clearCart = () => {
        setCartItems([]);
        localStorage.removeItem("cartItems");
        console.log("Cart cleared");
    };

    return (
        <CartContext.Provider value={{ cartItems, addToCart, removeFromCart, clearCart }}>
            {children}
        </CartContext.Provider>
    );
};
